import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HomePage } from "../../home/home";
import * as firebase from 'firebase';
import { OrdersCoServices } from '../../orders/services';

/**
 * Generated class for the SuperPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-super',
  templateUrl: 'super.html',
})
export class SuperPage {

  firestore: any;
  count: number = 0;
  term: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices,
    public loadingCtrl: LoadingController) {
    this.globals.getListRestaurants();
    this.firestore = firebase.firestore();
    //this.delete('19ffa982dc724e4bbddf','smxbboutarfas@gmail.com');
    //this.delete('a0227e2d57d841238a14','smxbboutarfas@gmail.com');

  }

  notify() {
    this.count = this.term.length;
  }

  async openRestaurant(restaurant) {
    this.globals.restaurant_uid = restaurant.UID;
    this.globals.RESTAURANT_TAX = restaurant.tax_percentage;
    this.globals.user_name = 'MyChefTool';
    this.globals.user_email = 'dev@mycheftool.com';
    this.globals.user_rol = 'admin';
    this.globals.user_type = 'super';
    await this.globals.getRestaurant(this.globals.restaurant_uid);
    await this.getWaiter();
    this.navCtrl.push(HomePage);

  }

  async getWaiter() {
    var users = await this.ordersCoServices.getAccessCodes();

    for (let user of users) {
      for (let restaurant of this.globals.objectToArray(user.restaurants)) {
        if (restaurant.UID_RESTAURANT == this.globals.restaurant_uid) {
          if (restaurant.rol == 'admin') {
            this.globals.waiter = user.name;
            this.globals.waiter_uid = user.UID;
          }
        }
      }
    }
  }

  async delete(uid, email) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    await this.deleteby('cashs', uid);
    await this.deleteby('customers', uid);
    await this.deleteby('delibery_note', uid);
    await this.deleteby('dish', uid);
    await this.deleteby('expenses', uid);
    await this.deleteby('historial', uid);
    await this.deleteby('income', uid);
    await this.deleteby('ingredients', uid);
    await this.deleteby('invoices', uid);
    await this.deleteby('menus', uid);
    await this.deleteby('products', uid);
    await this.deleteby('providers', uid);
    await this.deleteby('reservations', uid);
    await this.deleteby('rooms', uid);
    await this.deleteby('tables', uid);
    await this.deleteby('tickets', uid);
    await this.deleteby('variations', uid);
    await this.deleteby('tables', uid);

    loadingPopup.dismiss();

    await this.firestore.collection('restaurants').doc(uid).delete();

    await this.deletebyEmail(email);

  }

  async deleteby(collection, uid) {
    var jobskill_query = this.firestore.collection(collection).where('UID_RESTAURANT', '==', uid);
    jobskill_query.get().then(function (querySnapshot) {
      querySnapshot.forEach(async function (doc) {
        await doc.ref.delete();
      });
    });
  }

  async deletebyEmail(email) {
    var jobskill_query = this.firestore.collection('users').where('email', '==', email);
    jobskill_query.get().then(function (querySnapshot) {
      querySnapshot.forEach(async function (doc) {
        await doc.ref.delete();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/super/super.ts